import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const MissionSection = () => {
  const values = [
  {
    icon: "Scale",
    title: "Fairness",
    description: "Every candidate deserves to be judged on merit, not appearance or background."
  },
  {
    icon: "Lock",
    title: "Privacy",
    description: "Your personal information stays protected until you choose to share it."
  },
  {
    icon: "Zap",
    title: "Efficiency",
    description: "Streamlined processes that save time for both job seekers and employers."
  }];


  return (
    <section className="py-20 lg:py-32 bg-muted/20">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div>
            <div className="inline-flex items-center px-4 py-2 rounded-full bg-success/10 text-success text-sm font-medium mb-6">
              <Icon name="Heart" size={16} className="mr-2" />
              Our Mission
            </div>
            
            <h2 className="text-3xl lg:text-5xl font-bold text-foreground mb-6">
              Building a More
              <span className="text-primary block">Inclusive Future</span>
            </h2>
            
            <p className="text-xl text-muted-foreground mb-8 leading-relaxed">
              At Workfolio, we believe that talent comes in all forms and from all backgrounds. 
              Our mission is to create a recruitment platform where skills and potential matter more 
              than demographics, fostering truly diverse and inclusive workplaces across Norway.
            </p>
            
            {/* Values */}
            <div className="space-y-6">
              {values?.map((value, index) =>
              <div key={index} className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center">
                    <Icon name={value?.icon} size={24} className="text-primary" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-foreground mb-2">
                      {value?.title}
                    </h3>
                    <p className="text-muted-foreground">
                      {value?.description}
                    </p>
                  </div>
                </div>
              )}
            </div>
            
            {/* CTA */}
            <div className="mt-8 pt-8 border-t border-border">
              <a
                href="/about"
                className="inline-flex items-center text-primary font-medium hover:text-primary/80 transition-colors">

                Learn more about our story
                <Icon name="ArrowRight" size={20} className="ml-2" />
              </a>
            </div>
          </div>
          
          {/* Image */}
          <div className="relative">
            <div className="relative z-10">
              <Image
                src="https://images.unsplash.com/photo-1624555130581-1d9cca783bc0"
                alt="Diverse team of professionals working together around a conference table in bright modern office"
                className="rounded-2xl shadow-elevation-lg w-full h-[500px] object-cover" />

              
              {/* Overlay Stats */}
              <div className="absolute bottom-6 left-6 right-6">
                <div className="bg-card/90 backdrop-blur-md rounded-xl p-4 border border-border/50">
                  <div className="grid grid-cols-2 gap-4 text-center">
                    <div>
                      <div className="text-2xl font-bold text-primary">40%</div>
                      <div className="text-xs text-muted-foreground">More Diverse Hires</div>
                    </div>
                    <div>
                      <div className="text-2xl font-bold text-success">60%</div>
                      <div className="text-xs text-muted-foreground">Faster Hiring</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Background Decoration */}
            <div className="absolute inset-0 bg-gradient-to-br from-primary/10 to-accent/10 rounded-2xl blur-3xl transform scale-110 -z-10"></div>
            
            {/* Floating Elements */}
            <div className="absolute -top-4 -right-4 w-20 h-20 bg-success/20 rounded-full blur-xl animate-pulse"></div>
            <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-primary/20 rounded-full blur-xl animate-pulse" style={{ animationDelay: '1s' }}></div>
          </div>
        </div>
      </div>
    </section>);

};

export default MissionSection;